import * as React from 'react'
export const LinkedinIcon = () => {
  return (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_1752_1798)'>
        <path
          d='M4.53333 2.11771C4.53333 2.71031 4.31851 3.214 3.88889 3.62882C3.45927 4.04364 2.90371 4.25104 2.22222 4.25104C1.57038 4.25104 1.03704 4.04364 0.622222 3.62882C0.2074 3.214 0 2.71031 0 2.11771C0 1.49549 0.2074 0.984375 0.622222 0.584375C1.03704 0.184375 1.58518 -0.015625 2.26667 -0.015625C2.94816 -0.015625 3.48889 0.184375 3.88889 0.584375C4.28889 0.984375 4.50371 1.49549 4.53333 2.11771ZM0.133333 19.6733V5.93993H4.4V19.6733H0.133333ZM6.93333 10.3399C6.93333 9.06586 6.90371 7.5992 6.84444 5.93993H10.5333L10.7556 7.85104H10.8444C11.7333 6.36955 13.1407 5.62882 15.0667 5.62882C16.5482 5.62882 17.7407 6.12511 18.6444 7.11771C19.5482 8.11031 20 9.58438 20 11.5399V19.6733H15.7333V12.0733C15.7333 10.0881 15.0074 9.09549 13.5556 9.09549C12.5185 9.09549 11.7926 9.62882 11.3778 10.6955C11.2889 10.8733 11.2444 11.2288 11.2444 11.7622V19.6733H6.93333V10.3399Z'
          fill='current'
        />
      </g>
      <defs>
        <clipPath id='clip0_1752_1798'>
          <rect width='20' height='20' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}
